/**
 * @author        nico@zumper.com (Nico Rattazzi)
 * @copyright     Copyright (c) 2017, Zumper
 */

import { createAction } from 'redux-actions'
import * as ActionC from './constants'

export function addFavorites(idObj, timestamp) {
  return {
    type: ActionC.ADD_TO_FAVORITES,
    listingId: idObj.listingId,
    buildingId: idObj.buildingId,
    timestamp,
  }
}

export function convertLocalFavorites(localFavorites) {
  return {
    type: ActionC.CONVERT_LOCAL_FAVORITES,
    localFavorites,
  }
}

export function removeFavorites(idObj, timestamp) {
  return {
    type: ActionC.REMOVE_FROM_FAVORITES,
    listingId: idObj.listingId,
    buildingId: idObj.buildingId,
    timestamp,
  }
}

export function setUser({ user }) {
  return {
    type: ActionC.SET_USER,
    user,
  }
}

export function setLocalUser(user) {
  return {
    type: ActionC.SET_LOCAL_USER,
    user,
  }
}

export function clearBundle() {
  return {
    type: ActionC.CLEAR_BUNDLE,
  }
}

export function setBundle(bundle) {
  return {
    type: ActionC.SET_BUNDLE,
    bundle,
  }
}

export function showButterBar(butterBar = {}) {
  return {
    type: ActionC.ADD_BUTTER_BAR,
    butterBar,
  }
}

/**
 * @param {import('@zcode/state-type').Listable} [item]
 */
export function setHoveredItem(item) {
  return {
    type: ActionC.SET_HOVERED_ITEM,
    item,
  }
}

export function setHoveredClusterItem(item) {
  return {
    type: ActionC.SET_HOVERED_CLUSTER_ITEM,
    payload: item,
  }
}

export function removeButterBar(butterBarId) {
  return {
    type: ActionC.REMOVE_BUTTER_BAR,
    butterBarId,
  }
}

export function removeItemFromList(entity) {
  return {
    type: ActionC.ON_REMOVE_ITEM_FROM_LIST,
    entity,
  }
}

export function updateLocation({ location, reset }) {
  return {
    type: ActionC.UPDATE_LOCATION,
    location,
    reset,
  }
}

export function updateSearchUI(args) {
  return {
    ...args,
    type: ActionC.UPDATE_SEARCH_UI,
  }
}

export const setFiltersViewStartPoint = createAction(ActionC.SET_FILTERS_VIEW_START_POINT)

export const clearFiltersViewStartPoint = createAction(ActionC.CLEAR_FILTERS_VIEW_START_POINT)

export function focusNavbarSearch() {
  return {
    type: ActionC.UPDATE_SEARCH_UI,
    key: 'isNavbarSearchFocused',
    value: true,
  }
}

export function setFiltersView(value) {
  return {
    type: ActionC.UPDATE_SEARCH_UI,
    key: 'isFiltersView',
    value,
  }
}

export const clearHood = createAction(ActionC.CLEAR_HOOD)

export const clearCities = createAction(ActionC.CLEAR_CITIES)

/**
 *
 * @typedef { equalApplyMessaged: unknown; equalCheckAvailabilityMessaged: unknown; equalTourMessaged: unknown; favorites: unknown; flaggedIds: import('@zcode/state-type').FlaggedIds; messaged: unknown; user: import('@zcode/bizos').RawLocalUser | undefined; visited: unknown } LocalizerValues
 * @param {LocalizerValues} payload
 * @returns {{ payload: LocalizerValues; type: typeof ActionC.RECEIVE_LOCALIZER_VALUES }}
 */
export const receiveLocalizerValues = (payload) => ({
  type: ActionC.RECEIVE_LOCALIZER_VALUES,
  payload,
})

// TODO - move to appropriate `modules/` folder once we get break localguide from currentSearch
// and change all this with createAction

// city
export const beginLoadingCity = (params) => ({
  type: ActionC.GET_CITIES_REQUEST,
  params,
})
export const receiveCity = ({ city }) => ({
  type: ActionC.GET_CITIES_SUCCESS,
  city,
})
export const errorLoadingCity = ({ error, params }) => ({
  type: ActionC.GET_CITIES_ERROR,
  error,
  params,
})

// hood
export const beginLoadingHood = (params) => ({
  type: ActionC.GET_HOODS_REQUEST,
  params,
})
export const receiveHood = ({ hood }) => ({
  type: ActionC.GET_HOODS_SUCCESS,
  hood,
})
